<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Homeowner Category Details"></fury-breadcrumbs>
    </fury-page-layout-header>
    <fury-page-layout-content [@fadeInUp]>
      <div class="describ-item">
        <div class="col-title">
          <h3>Description</h3>
        </div>
        <div class="col-desc">
          <p>
            {{categoryDetails?.description}}
          </p>
        </div>
      </div>
      <h3>{{categoryDetails?.title}}</h3>
      <div class="imgBox">
        
        <img
        [src]="categoryDetails?.bannerImage">
      </div>
      <div class="describ-item">
        <div class="col-title">
          <h3>Meta Title</h3>
        </div>
        <div class="col-desc">
          <p>
            {{categoryDetails?.metaTitle}}
          </p>
        </div>
      </div>
      <div class="describ-item">
        <div class="col-title">
          <h3>Meta Description</h3>
        </div>
        <div class="col-desc">
          <p>
            {{categoryDetails?.metaDescription}}
          </p>
        </div>
      </div>
    </fury-page-layout-content>


  </fury-page-layout>
  
  
  
    
  
